import { render, staticRenderFns } from "./AscMxStatusIcon.vue?vue&type=template&id=626e6d4a&"
import script from "./AscMxStatusIcon.vue?vue&type=script&lang=js&"
export * from "./AscMxStatusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports